import React, { useEffect, useState } from "react";
import { Segmented } from "antd";
import { useTranslation } from "react-i18next";
// import FutureMeetingsTable from "./FutureMeetingsTable";
// import PastMeetingsTable from "./PastMeetingsTable";
import styles from "./index.module.scss";
import FutureMeetingsTable from "./FutureMeetingsTable";
import PastMeetingsTable from "./PastMeetingsTable";
import { useMeetingTableGet } from "../../../../../../hooks/api/meetings";
import { useLocation, useParams } from "react-router";
import { useVaadTabs } from "../context";

type TabType = "future" | "past";

export default function MeetingsTab(): React.ReactElement {
  const { id } = useParams();
  const location = useLocation();
  const { setMeetingsSubTab } = useVaadTabs();
  // Default is always "future". The "past" sub-tab is only restored when we
  // return here from editing a past meeting, which passes it via location
  // state — so it doesn't stick globally across fresh page visits.
  const restoredSubTab = (location.state as { meetingsSubTab?: TabType } | null)
    ?.meetingsSubTab;
  const [activeTab, setActiveTab] = useState<TabType>(
    restoredSubTab || "future",
  );
  const { t } = useTranslation();
  const [futureTotal, setFutureTotal] = useState(0);
  const [pastTotal, setPastTotal] = useState(0);
  const pastTableGet = useMeetingTableGet();
  const futureTableGet = useMeetingTableGet();

  useEffect(() => {
    pastTableGet.fetch({ period: "past", vaadId: id }).then((res) => {
      if (res) {
        setPastTotal(res.total);
      }
    });
    futureTableGet.fetch({ period: "future", vaadId: id }).then((res) => {
      if (res) {
        setFutureTotal(res.total);
      }
    });
  }, []);

  const handleTabChange = (value: TabType) => {
    setActiveTab(value);
    setMeetingsSubTab(value);
  };

  const SEGMENT_OPTIONS = [
    { label: `Future meetings (${futureTotal})`, value: "future" as TabType },
    { label: `Past meetings (${pastTotal})`, value: "past" as TabType },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Segmented
          options={SEGMENT_OPTIONS}
          value={activeTab}
          onChange={(value) => handleTabChange(value as TabType)} // ← handleTabChange
          className={styles.segmented}
        />
      </div>

      <div className={styles.content}>
        {activeTab === "future" ? (
          <FutureMeetingsTable onTotalChange={setFutureTotal} />
        ) : (
          <PastMeetingsTable onTotalChange={setPastTotal} />
        )}
      </div>
    </div>
  );
}
